export default __webpack_public_path__ + "static/media/90_desktop.62735bb7.jpg";